<template>
  <payment-result-component :transactionId="transactionId"></payment-result-component>    
</template>

<script>
import PaymentResultComponent from '../components/PaymentResultComponent'

export default {
  props: {
    transactionId: {
      type: String,
      default() { return null; }
    }
  },
  components: {
    PaymentResultComponent
  },  
}
</script>